export const getDeviceId = () =>{
    return navigator.userAgent.toLowerCase();
};